/* tslint:disable */
/* eslint:disable */

VisitWidget.Events.FlyoutLoaded = class FlyoutLoaded {
  public eventName: string;
  constructor() {
    this.eventName = "FlyoutLoaded";
  }
};
